export default __webpack_public_path__ + "static/media/38_oranje.355193e5.JPG";